module.exports = __webpack_public_path__ + "files/b00f93db52038ee1134b394c301d9fab.svg";